import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlContainer, FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material';
import {Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, startWith, switchMap} from 'rxjs/operators';
import {PleitoService} from "../../../service/pleito.service";

@Component({
  selector: 'app-autocomplete-empresa',
  templateUrl: './autocomplete-empresa.component.html',
  styleUrls: ['./autocomplete-empresa.component.scss']
})
export class AutocompleteEmpresaComponent implements OnInit, OnDestroy {

  @Input()
  label: string = 'Empresa';

  @Input()
  idPleito: number;

  @Input()
  controlName: string;

  @Output()
  selecionar: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  limpar: EventEmitter<string> = new EventEmitter<string>();

  empresas: string[];
  autocompleteSubscription: Subscription;

  formControl: FormControl;

  constructor(
    private readonly pleitoService: PleitoService,
    private readonly controlContainer: ControlContainer
  ) {
  }

  ngOnInit(): void {
    this.formControl = this.controlContainer.control.get(this.controlName) as FormControl;
    this.empresas = [];
    this.initAutocomplete();
  }

  ngOnDestroy(): void {
    this.autocompleteSubscription.unsubscribe();
  }

  selecionarProduto($event: MatAutocompleteSelectedEvent): void {
    this.formControl.patchValue($event.option.value);
    this.formControl.disable();
    this.selecionar.emit($event.option.value);
  }

  limparSelecionado(): void {
    const empresa: string = this.formControl.value;
    this.formControl.patchValue(null);
    this.formControl.enable();
    this.empresas.length = 0;
    this.limpar.emit(empresa);
  }

  exibirProdutoNome(empresa): string {
    return empresa ? empresa : undefined;
  }

  private initAutocomplete(): void {
    this.autocompleteSubscription = this.formControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      filter(nome => this.idPleito && nome && nome.length >= 2),
      switchMap(empresa => this.pleitoService.obterPorNome(this.idPleito, empresa))
    ).subscribe(empresas => {
      this.empresas = empresas;
    });
  }
}
